import React from 'react';
import { StyleSheet } from 'react-native';
import { DNABox, DNACard, DNAText, Iffy, util } from '@alucio/lux-ui';
import { DNARowsComponent } from 'src/components/DNA/FlatList/Rows/types';
import { FolderORM } from 'src/types/types';
import FolderIcon from 'src/assets/images/FolderVector';
import DNAFolderStatusChip from 'src/components/DNA/Chip/DNAFolderStatusChip';
import { DNAFolderDefaultRowProps } from '../default/DNAFolderDefaultRow';

const styles = StyleSheet.create({
  folderRow: {
    paddingVertical: 12,
  },
  folderTitle: {
    marginLeft: 12,
  },
});

const DNAFolderDashboardRow: DNARowsComponent<FolderORM, DNAFolderDefaultRowProps> = (props) => {
  const { ORM: folderORM } = props;

  const onPress = (): void => {
    props.onPress?.(folderORM);
  };

  return (
    <DNACard
      appearance="flat"
      interactive="pressable"
      onPress={onPress}
      style={util.mergeStyles(undefined, styles.folderRow)}
    >
      <DNABox appearance="col" style={{ paddingHorizontal: 4 }}>
        <DNABox fill>
          <DNABox>
            <FolderIcon />
          </DNABox>
          <DNAText style={styles.folderTitle} numberOfLines={1}>{folderORM.model.name}</DNAText>
          <Iffy is={folderORM.meta.isSharedFolder && !folderORM.meta.isSharedWithTheUser}>
            <DNAFolderStatusChip folderStatus="SHARED" style={{ marginLeft: 8 }} />
          </Iffy>
          <Iffy is={folderORM.meta.isSharedWithTheUser}>
            <DNAFolderStatusChip folderStatus="SHARED_WITH_ME" style={{ marginLeft: 8 }} />
          </Iffy>
        </DNABox>
      </DNABox>
    </DNACard>
  );
}

export default DNAFolderDashboardRow;
